import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';

//constants
import { LAYOUT_MODE_TYPES } from "../../Components/constants/layout";
import { changeLayoutModeAction } from '../../store/layouts/reducer';

interface LightDarkProps {
    layoutMode?: string;
    onChangeLayoutMode?: (mode: string) => void;
}

const LightDark = ({ layoutMode: propLayoutMode, onChangeLayoutMode }: LightDarkProps) => {
    const dispatch = useDispatch();
    
    // Get layout mode from Redux store
    const reduxLayoutMode = useSelector((state: RootState) => state.Layout.layoutModeType);
    
    // Use Redux state or fallback to props
    const currentLayoutMode = propLayoutMode || reduxLayoutMode;
    
    const toggleMode = () => {
        const newMode = currentLayoutMode === LAYOUT_MODE_TYPES.DARKMODE 
            ? LAYOUT_MODE_TYPES.LIGHTMODE 
            : LAYOUT_MODE_TYPES.DARKMODE;
        
        // Update Redux state
        dispatch(changeLayoutModeAction(newMode as any));
        
        // Call prop callback if provided (for backward compatibility)
        if (onChangeLayoutMode) {
            onChangeLayoutMode(newMode);
        }
    };

    return (
        <div className="ms-1 header-item d-none d-sm-flex">
            <button
                onClick={toggleMode}
                type="button" 
                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode"
                aria-label={`Switch to ${currentLayoutMode === LAYOUT_MODE_TYPES.DARKMODE ? 'light' : 'dark'} mode`}
            >
                <i className={`bx ${currentLayoutMode === LAYOUT_MODE_TYPES.DARKMODE ? 'bx-sun' : 'bx-moon'} fs-22`}></i>
            </button>
        </div>
    );
};

export default LightDark;